import axios from "../interceptors/axios";

export class LikeProjectService {
  store = async (data) => {
    try {
      const response = await axios.post("/api/likes/projects", data);
      return response.data;
    } catch (error) {
      console.error("Error:", error);
      if (error.response) {
        console.error("Status:", error.response.status);
        console.error("Data:", error.response.data);
      } else {
        console.error("Error Message:", error.message);
      }
      throw error;
    }
  };
}

export class LikeTitleService {
  store = async (data) => {
    try {
      const response = await axios.post("/api/likes/titles", data);
      return response.data;
    } catch (error) {
      console.error("Error:", error);
      if (error.response) {
        console.error("Status:", error.response.status);
        console.error("Data:", error.response.data);
      } else {
        console.error("Error Message:", error.message);
      }
      throw error;
    }
  };
}
